import React from "react";

import SmsFailedIcon from "@mui/icons-material/SmsFailed";

function FailureIcon({ iconColor, iconSize = "small", ...other }) {
    return <SmsFailedIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default FailureIcon;
